module.exports = "/fonts/fa-brands-400.eot?c1868c9545d2de1cf8488f1dadd8c9d0";